import { AxiosInstance, AxiosResponse } from "axios";
import DepartmentModel from "@/models/DepartmentModel";
import Shared from "@/common/shared";

export default class DepartmentService {
  private axiosInstance: AxiosInstance;

  public constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  public async getDepartments(): Promise<DepartmentModel[]> {
    const url = `/Department`;
    const res: AxiosResponse<DepartmentModel[]> = await this.axiosInstance.get<DepartmentModel[]>(url);
    return res.data;
  }

  public async addDepartment(department: DepartmentModel): Promise<DepartmentModel> {
    const url = `/Department`;
    const res: AxiosResponse<DepartmentModel | string> = await this.axiosInstance.post<DepartmentModel | string>(
      url,
      department,
    );
    if (res.status === 409) {
      const conflictError = new Error();
      conflictError.name = Shared.conflict;
      conflictError.message = res.data as string;
      return Promise.reject(conflictError);
    }
    return res.data as DepartmentModel;
  }

  public async updateDepartment(department: DepartmentModel): Promise<DepartmentModel> {
    const url = `/Department/${department.id}`;
    const res: AxiosResponse<DepartmentModel | string> = await this.axiosInstance.patch<DepartmentModel | string>(
      url,
      department,
    );
    if (res.status === 409) {
      const conflictError = new Error();
      conflictError.name = Shared.conflict;
      conflictError.message = res.data as string;
      return Promise.reject(conflictError);
    }
    return res.data as DepartmentModel;
  }

  public async getDepartmentById(id: number): Promise<DepartmentModel> {
    const url = `/Department/${id}`;
    const res: AxiosResponse<DepartmentModel> = await this.axiosInstance.get<DepartmentModel>(url);
    return res.data;
  }

  public async deleteDepartment(id: number): Promise<boolean> {
    const url = `/Department/${id}`;
    const res: AxiosResponse<DepartmentModel | string> = await this.axiosInstance.delete<DepartmentModel | string>(url);
    if (res.status === 409) {
      const conflictError = new Error();
      conflictError.name = Shared.conflict;
      conflictError.message = res.data as string;
      return Promise.reject(conflictError);
    }
    return true;
  }
}
